module.exports = __webpack_public_path__ + "static/media/Cost center.784b1a6b.svg";